const spreadSheetsIndex = {
  restaurant: {
    spreadSheetId: '1NNxztjUZ1pZHNXjV7eJ2mCSWEW4S92xWyNbkPmhETSE',
    spreadSheetTitle: '数値計画（資金調達・収支・資金繰り）- 飲食店向け',
    desc: '資金調達表・収支計画表・資金繰り表がセットになった飲食店向けのGoogleスプレッドシートです。'
  },
  beauty: {
    spreadSheetId: '1BM4_me9pTaKNEIZJTYcYR9BhCKHGjEV_GqPuDTsB_xA',
    spreadSheetTitle: '数値計画（資金調達・収支・資金繰り）- エステサロン向け',
    desc: '資金調達表・収支計画表・資金繰り表がセットになったエステサロン向けのGoogleスプレッドシートです。'
  },
  competing: {
    spreadSheetId: '1XLXOraPnLOhnmnxid3NswCdDgRAe1_Ph_rQHxLeCeWY',
    spreadSheetTitle: '競合店調査シート',
    desc: '競合店調査シートのテンプレートです。飲食店向けの例文が入っています。'
  },
  concept: {
    spreadSheetId: '17_aJortsQvwGe68nMlzIROgLbavOJhAKGSsMKiLZsNw',
    spreadSheetTitle: 'コンセプトシートとメニューリスト',
    desc: 'コンセプトシートとメニューリストのテンプレートです。飲食店向けの例文が入っています。'
  },
}

export default spreadSheetsIndex
